export const ACADEMY_BACK_LINK_TEST_IDS = {
  root: 'academy-back-link',
} as const

export const ACADEMY_HEADER_TEST_IDS = {
  root: 'academy-header',
} as const

export const ACADEMY_HEADER_NAV_TEST_IDS = {
  root: 'academy-header-nav',
  desktop: 'academy-navbar-desktop',
  quickStartDesktop: 'academy-navbar-desktop-quick-start',
  breadcrumbs: 'academy-header-nav-breadcrumbs',
  searchBar: 'academy-header-nav-search-bar',
  userActions: 'academy-header-nav-user-actions',
} as const

export const NAVBAR_BREADCRUMBS_TEST_IDS = {
  root: 'navbar-breadcrumbs',
} as const

export const NAVBAR_SEARCH_BAR_TEST_IDS = {
  root: 'navbar-search-bar',
} as const

export const NAVBAR_USER_ACTIONS_TEST_IDS = {
  root: 'navbar-user-actions',
} as const

export const ACADEMY_HEADER_WRAPPER_TEST_IDS = {
  root: 'academy-header-wrapper',
} as const

export const ACADEMY_INITIALIZATION_TEST_IDS = {
  root: 'academy-initialization',
} as const

export const ACADEMY_LAYOUT_TEST_IDS = {
  root: 'academy-layout',
  codeSandboxTooltip: 'academy-layout-code-sandbox-tooltip',
} as const

export const ACADEMY_MOBILE_MENU_TEST_IDS = {
  root: 'academy-mobile-menu',
  guestNavigation: 'academy-mobile-menu-guest-navigation',
} as const

export const CODE_SANDBOX_COMING_SOON_TEST_IDS = {
  root: 'code-sandbox-coming-soon',
} as const

export const CODE_SANDBOX_MENU_TEST_IDS = {
  root: 'code-sandbox-menu',
} as const

export const CONTENT_NAV_TEST_IDS = {
  root: 'content-nav',
} as const

export const DOCUMENTATION_ARTICLE_TEST_IDS = {
  root: 'documentation-article',
} as const

export const DOCUMENTATION_ARTICLE_SELECTORS_TEST_IDS = {
  root: 'documentation-article-selectors',
} as const

export const DOCUMENTATION_LAYOUT_SHELL_TEST_IDS = {
  root: 'documentation-layout-shell',
} as const

export const DOCUMENTATION_MENU_TEST_IDS = {
  root: 'documentation-menu',
} as const

export const DOCUMENTATION_NAV_LINKS_TEST_IDS = {
  root: 'documentation-nav-links',
} as const

export const ERROR_STATE_TEST_IDS = {
  root: 'error-state',
} as const

export const IMAGE_LIGHTBOX_TEST_IDS = {
  root: 'image-lightbox',
} as const

export const MARKDOWN_RENDERER_TEST_IDS = {
  root: 'markdown-renderer',
  infoBox: 'markdown-renderer-info-box',
  collapsible: 'markdown-renderer-collapsible',
} as const

export const POPULAR_TOPICS_SECTION_TEST_IDS = {
  root: 'popular-topics-section',
  topicCard: 'popular-topics-topic-card',
  topicIcon: 'popular-topics-topic-icon',
} as const

export const QUICK_START_ARTICLE_SELECTORS_TEST_IDS = {
  root: 'quick-start-article-selectors',
} as const

export const QUICK_START_LANGUAGE_SELECTOR_TEST_IDS = {
  root: 'quick-start-language-selector',
} as const

export const QUICK_START_LAYOUT_SHELL_TEST_IDS = {
  root: 'quick-start-layout-shell',
} as const

export const QUICK_START_PAGE_COMPONENTS_TEST_IDS = {
  jsonLd: 'quick-start-json-ld',
  navLinks: 'quick-start-nav-links',
} as const

export const QUICK_START_JSON_LD_TEST_IDS = {
  root: 'quick-start-json-ld',
} as const

export const SCROLL_TO_TOP_BUTTON_TEST_IDS = {
  root: 'scroll-to-top-button',
} as const

export const TOPIC_ICON_ATOM_TEST_IDS = {
  root: 'topic-icon-atom',
} as const

export const TOPIC_ICON_BUILDING_TEST_IDS = {
  root: 'topic-icon-building',
} as const

export const TOPIC_ICON_CIRCUIT_TEST_IDS = {
  root: 'topic-icon-circuit',
} as const

export const TOPIC_ICON_ROCKET_TEST_IDS = {
  root: 'topic-icon-rocket',
} as const

export const TUTORIAL_MENU_TEST_IDS = {
  root: 'tutorial-menu',
} as const

export const TUTORIAL_SIDEBAR_TEST_IDS = {
  root: 'tutorial-sidebar',
} as const
